import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import robot from "../../../assets/bot-small.png";
import { DollarSign, Users, ShoppingBag, Package } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";

export default function Dsidebar({ showsidebar, toggleSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const isExpertPath = location.pathname.includes("/expert-dashboard");
  const isRetailPath = location.pathname.includes("/retailer-dashboard");
  
  const basePath = isExpertPath 
    ? "/expert-dashboard" 
    : isRetailPath
    ? "/retailer-dashboard"
    : "/farmer-dashboard";
  
  const isActive = (pathSegment) => location.pathname.includes(pathSegment);
  
  return (
    <div className={`sidebar ${showsidebar ? "sidereduce" : ""}`}>
      <div className="sidebar-header">
        <span>
          <img
            src="/AGRICVERSE_LOGO.png"
            alt="AgricVerse Logo"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </span>
        <i className="fas fa-times unseen" onClick={toggleSidebar}></i>
      </div>

      <div className="nav-link-s">
        <div className="head-links">
          <p>Menu</p>
        </div>
        
        <Link
          to={basePath}
          className={
            location.pathname === basePath ? "activea" : ""
          }
          onClick={toggleSidebar}
        >
          <div className="nav-as">
            <i className="fas fa-home"></i>
            <p>Overview</p>
          </div>
        </Link>

        {/* Farmer-specific links */}
        {!isExpertPath && !isRetailPath && (
          <>
            <Link
              to="/farmer-dashboard/produce"
              onClick={toggleSidebar}
              className={isActive("produce") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-seedling"></i>
                <p>My Produce</p>
              </div>
            </Link>

            <Link
              to="/farmer-dashboard/myfarm"
              onClick={toggleSidebar}
              className={isActive("myfarm") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-tractor"></i>
                <p>My Farm</p>
              </div>
            </Link>

            <Link
              to="/farmer-dashboard/orders"
              onClick={toggleSidebar}
              className={isActive("orders") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-shopping-cart"></i>
                <p>My Orders</p>
              </div>
            </Link>

            <Link
              to="/farmer-dashboard/withdrawals"
              onClick={toggleSidebar}
              className={isActive("withdrawals") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-credit-card"></i>
                <p>Withdrawals</p>
              </div>
            </Link>
            
            <Link
              to="/farmer-dashboard/sell"
              onClick={toggleSidebar}
              className={isActive("sell") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-store"></i>
                <p>Sell</p>
              </div>
            </Link>
          </>
        )}

        {/* Expert-specific links */}
        {isExpertPath && (
          <>
            <Link
              to="/expert-dashboard/transactions"
              onClick={toggleSidebar}
              className={isActive("transactions") ? "activea" : ""}
            >
              <div className="nav-as">
                <DollarSign size={18}/>
                <p>Transaction History</p>
              </div>
            </Link>

            <Link
              to="/expert-dashboard/withdrawals"
              onClick={toggleSidebar}
              className={isActive("withdrawals") ? "activea" : ""}
            >
              <div className="nav-as">
                <i className="fas fa-credit-card"></i>
                <p>Withdrawals</p>
              </div>
            </Link>
          </>
        )}

        {/* Retailer-specific links */}
        {isRetailPath && (
          <>
            <Link
              to="/marketplace"
              onClick={toggleSidebar}
              className={location.pathname === "/marketplace" ? "activea" : ""}
            >
              <div className="nav-as">
                <Package size={18} />
                <p>Marketplace</p>
              </div>
            </Link>

            <Link
              to="/retailer-dashboard/orders"
              onClick={toggleSidebar}
              className={isActive("orders") ? "activea" : ""}
            >
              <div className="nav-as">
                <ShoppingBag size={18} />
                <p>My Orders</p>
              </div>
            </Link>
          </>
        )}

        {/* Common links for all user types */}
        <Link
          to={`${basePath}/messages`}
          onClick={toggleSidebar}
          className={isActive("messages") ? "activea" : ""}
        >
          <div className="nav-as">
            <i className="fas fa-comments"></i>
            <p>Messages</p>
          </div>
        </Link>
        
      </div>
     
      <div className="nav-link-s">
        <div className="head-links">
          <p>Other</p>
        </div>
        
        {/* Show Experts link only for farmers */}
        {!isExpertPath && !isRetailPath && (
          <Link
            to="/farmer-dashboard/experts"
            onClick={toggleSidebar}
            className={isActive("experts") ? "activea" : ""}
          >
            <div className="nav-as">
              <i className="fas fa-user-tie"></i>
              <p>Agric Experts</p>
            </div>
          </Link>
        )}

    
       
        {!isRetailPath && (
           <Link
          to={`${basePath}/appointments`}
          onClick={toggleSidebar}
          className={isActive("appointments") ? "activea" : ""}
        >
          <div className="nav-as">
            <i className="fas fa-calendar-alt"></i>
            <p>Appointments</p>
          </div>
        </Link>
        ) }
        
       

        <Link
          to={`${basePath}/settings`}
          onClick={toggleSidebar}
          className={isActive("settings") ? "activea" : ""}
        >
          <div className="nav-as">
            <i className="fas fa-sliders-h"></i>
            <p>Settings</p>
          </div>
        </Link>

        <button
          onClick={async () => {
            toggleSidebar();
            await logout();
            navigate('/');
          }}
          className="nav-as logout-btn"
          style={{
            background: 'none',
            border: 'none',
            width: '100%',
            color: 'inherit',
            fontSize: 'inherit',
            cursor: 'pointer',
            padding: '16px 20px',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}
        >
          <i className="fas fa-sign-out-alt"></i>
          <p>Logout</p>
        </button>
      </div>
    </div>
  );
}